/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DeclinedAction {
    CLIENT_DECLINED = 'ClientDeclined',
    ATTORNEY_DECLINED = 'AttorneyDeclined',
    REFER = 'Refer',
}
